"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = {
  name: 'DELETE',
  req: function req(payload) {
    if (payload.req.method === 'DELETE') {
      payload.req.headers = {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json'
      };
      var data = payload.req.data;

      if (_typeof(data) === 'object') {
        if (Object.keys(data).length === 0) {
          delete payload.req.data;
        } else {
          payload.req.data = {
            data: data
          };
        }
      }
    }

    return payload;
  }
};